(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2533],{

/***/ 2591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var ButtonLink = function(param) {
    var children = param.children, uri = param.uri;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: uri,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "px-4 py-2 mt-8 bg-white-lighter text-lg text-blue border-2 border-blue hover:bg-blue hover:text-white-light inline-block font-[sans-serif]",
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonLink);


/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    heartwalk: {
        title: "PPN Heartwalk 2026 | Evry Health",
        description: "Walked the PPN Heartwalk? Learn how to claim your $200 Evry Rewards milestone and explore the benefits in your Evry Health plan.",
        noindex: true
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "prior-authorization-request": {
        title: "Submit a Prior Authorization Request | Evry Health for Providers",
        description: "Submit the Texas Standard Prior Authorization Request Form to Evry Health online, attach clinical documents, and get your case reference number right away.",
        ogDescription: "Submit a prior authorization request to Evry Health online and get your case reference number right away.",
        twitterTitle: "Submit a Prior Authorization Request | Evry Health",
        twitterDescription: "Submit a prior authorization request online and get your case reference number right away."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "request-provider-addition": {
        title: "Request Provider Addition | Evry Health",
        description: "Request a provider to be added to the Evry Health network. Enter an NPI and we help fill in their practice details.",
        ogDescription: "Request a provider to be added to the Evry Health network.",
        twitterTitle: "Request Provider Addition | Evry Health",
        twitterDescription: "Request a provider for the Evry Health network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    "eligibility-verification": {
        title: "Eligibility Verification | Evry Health for Providers",
        description: "Providers can verify a member's current Evry Health eligibility and in-network status in real time.",
        ogDescription: "Real-time member eligibility and in-network status verification for Evry Health providers.",
        twitterTitle: "Eligibility Verification | Evry Health",
        twitterDescription: "Verify member eligibility and in-network status in real time."
    },
    "claims-verification": {
        title: "Claims Verification | Evry Health for Providers",
        description: "Providers can check the status of a submitted Evry Health claim and view the explanation of payment in real time.",
        ogDescription: "Real-time claim status and explanation of payment lookup for Evry Health providers.",
        twitterTitle: "Claims Verification | Evry Health",
        twitterDescription: "Check claim status and explanation of payment in real time."
    },
    "prior-auth-status": {
        title: "Prior Authorization Status | Evry Health for Providers",
        description: "Providers can check the prior authorizations on file for an Evry Health member that their NPI appears on.",
        ogDescription: "Check prior authorization status, determination and approved procedure lines for Evry Health members.",
        twitterTitle: "Prior Authorization Status | Evry Health",
        twitterDescription: "Check the prior authorizations on file for an Evry Health member."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 6259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CompareTable = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                className: "text-xl font-bold text-center md:text-3xl text-blue",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Evry Health"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                    className: "p-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-t-2 border-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Fully-insured, employer health plan"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                        className: "inline-block h-6",
                                        type: "image/svg+xml",
                                        data: "checkmark-blue.svg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-t-2 border-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Built to improve medical quality"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                        className: "inline-block h-6",
                                        type: "image/svg+xml",
                                        data: "checkmark-blue.svg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-t-2 border-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Integrated wellness plans for every employee"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                        className: "inline-block h-6",
                                        type: "image/svg+xml",
                                        data: "checkmark-blue.svg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-t-2 border-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Incentive wellness card for every employee"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                    className: "text-center text-blue",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                            className: "inline-block h-6 mt-8",
                                            type: "image/svg+xml",
                                            data: "checkmark-blue.svg"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "pt-4 md:pb-8 md:px-16",
                                            children: "Everyone gets personalized wellness benefits."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-t-2 border-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Designed to be mobile-first with an integrated iOS/Android app"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "text-center text-blue",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                        className: "inline-block h-6",
                                        type: "image/svg+xml",
                                        data: "checkmark-blue.svg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            className: "border-white border-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    className: "py-8 text-xl font-bold text-left text-grey",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "No copays or deductibles"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                    className: "text-center text-blue",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                            className: "inline-block h-6 mt-8",
                                            type: "image/svg+xml",
                                            data: "checkmark-blue.svg"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "my-4",
                                            children: "Our premier plan has no copays or deductibles."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompareTable);


/***/ }),

/***/ 3538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fadingOut":"section_fadingOut__ZY4x7","fadeOut":"section_fadeOut__E4vF6","fadingIn":"section_fadingIn__Q1dn6","fadeIn":"section_fadeIn__z9Mx8","section-bar":"section_section-bar__p2nXY","sectionImageRight":"section_sectionImageRight__aPuEP","whyChooseEvrysectionImageRight":"section_whyChooseEvrysectionImageRight__yInbM","prevArrow":"section_prevArrow__cyQub","nextArrow":"section_nextArrow__1wnkz","meetYourNewTeamSectionImageRight":"section_meetYourNewTeamSectionImageRight__AmkxL","sectionImageRightVirtualCare":"section_sectionImageRightVirtualCare__Wzv_i","virtualCareLady":"section_virtualCareLady__WgyzK","noTextWrap":"section_noTextWrap__PSVA5","ulclass":"section_ulclass__3lngx","ul":"section_ul__7HZsf","numberedList":"section_numberedList__eyVoS","chekmarkList":"section_chekmarkList__MNsU0","differenceBackground":"section_differenceBackground__Y2rnw","virtualCarePhone":"section_virtualCarePhone__cLyjo","homepagePhoneOne":"section_homepagePhoneOne__Fdlng","homepagePhoneTwo":"section_homepagePhoneTwo__E8F1p","cardBoxShadow":"section_cardBoxShadow__dwDsj","transformPhone":"section_transformPhone__4KwcT","transformDFWMap":"section_transformDFWMap__LXijJ","transformMobileText":"section_transformMobileText__kS3hI","greyCell":"section_greyCell__IH1f_","fileInput":"section_fileInput__ZgDbf","joinEvryNetworkUl":"section_joinEvryNetworkUl__YqtDF"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

}]);